export function getValidDate(input?: string | null | undefined) {
	if (!input) return new Date()
	const date = new Date(input)
	const isValid = date instanceof Date && !Number.isNaN(date)
	return isValid ? date : new Date()
}
